export default "__VITE_ASSET__DQGrlsuL__"